module.exports = __webpack_public_path__ + "static/media/pin5.d99d83f8.png";